import { SelectionType } from "@dextall/panel-hooks-editor-2d";
import { noop } from "../../../shared";
import { ImperialAndMetricDimensionEditor } from "../../editor-inputs/imperialAndMetricDimensionEditor";
import { RalColorPropertyEditor } from "../../editor-inputs/ralColorPropertyEditor";
import { PanelEditorScope } from "../../panels/panel-editor-scope";
import { Parameters } from "./parameters";
import { ParametersLabel } from "./parametersLabel";
import { usePanelSelectedComponent } from "./usePanelSelectedComponentHook";

type Props = {
    panelEditorScope: PanelEditorScope;
};

export const PanelLouvrePropertiesDockingPanelContent = ({ panelEditorScope }: Props) => {
    const { panel, selection } = usePanelSelectedComponent(panelEditorScope);

    if (!(panel && selection && selection.type === SelectionType.Louvre)) {
        return null;
    }

    const panelLouvre = panel.louvres[selection.index];

    return (
        <div className="fullheight">
            <Parameters>
                <RalColorPropertyEditor label="Color:" ralColor={panelLouvre.color} disabled />

                <RalColorPropertyEditor label="Sill color:" ralColor={panelLouvre.sillColor} disabled />

                <ImperialAndMetricDimensionEditor
                    value={panelLouvre.sillDepth}
                    onChange={noop}
                    title="Sill depth:"
                    disabled
                />

                <ParametersLabel label="Opening dimensions:" />

                <ImperialAndMetricDimensionEditor
                    value={panelLouvre.openingWidth}
                    onChange={noop}
                    title="Width:"
                    disabled
                />

                <ImperialAndMetricDimensionEditor
                    value={panelLouvre.openingHeight}
                    onChange={noop}
                    title="Height:"
                    disabled
                />
                <ParametersLabel label="Frame dimensions:" />

                <ImperialAndMetricDimensionEditor
                    value={panelLouvre.frameWidth}
                    onChange={noop}
                    title="Width:"
                    disabled
                />

                <ImperialAndMetricDimensionEditor
                    value={panelLouvre.frameHeight}
                    onChange={noop}
                    title="Height:"
                    disabled
                />
            </Parameters>
        </div>
    );
};
